/**
 * Employee Details pop-up, classic look: the person's active powers of
 * attorney, read only. Rows in the pop-up's own details-row style.
 */
import React from 'react';
import { powerLine, useEmployeePowersOfAttorney } from './usePowerOfAttorney';

function Lines({ items, otherSide }) {
  if (items.length === 0) return 'None';
  return items.map((poa) => <div key={poa.id}>{powerLine(poa, otherSide)}</div>);
}

export default function EmployeePowersOfAttorney({ employeeId }) {
  const { loading, given, held, error } = useEmployeePowersOfAttorney(employeeId);

  if (loading) {
    return (
      <div className="details-row">
        <span className="label">Loading...</span>
      </div>
    );
  }
  if (error) {
    return (
      <div className="details-row">
        <span className="value" role="alert">{error}</span>
      </div>
    );
  }
  return (
    <>
      <div className="details-row">
        <span className="label">Holds from:</span>
        <span className="value"><Lines items={held} otherSide="grantor" /></span>
      </div>
      <div className="details-row">
        <span className="label">Gives to:</span>
        <span className="value"><Lines items={given} otherSide="grantee" /></span>
      </div>
    </>
  );
}
